import { render, staticRenderFns } from "./PageBUSES.vue?vue&type=template&id=1589ce07"
import script from "./PageBUSES.vue?vue&type=script&lang=js"
export * from "./PageBUSES.vue?vue&type=script&lang=js"
import style0 from "./PageBUSES.vue?vue&type=style&index=0&id=1589ce07&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports